var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailPoiEscalator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_6976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97949 43.8979H24.9673L47.247 21.6182",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6097 24.1122L50.0207 18.8447L44.7554 20.2557L48.6097 24.1122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3981 19.5928C54.3981 20.2431 54.2699 20.887 54.0206 21.4876C53.7714 22.0882 53.406 22.6337 52.9456 23.0928L28.2377 47.8116C27.3095 48.7402 26.0507 49.2626 24.7377 49.2641H7.5593C6.89945 49.278 6.24347 49.16 5.62981 48.917C5.01615 48.6741 4.45715 48.3111 3.98559 47.8493C3.51402 47.3876 3.13938 46.8363 2.88361 46.2279C2.62784 45.6195 2.49609 44.9661 2.49609 44.3061C2.49609 43.6461 2.62784 42.9928 2.88361 42.3843C3.13938 41.7759 3.51402 41.2247 3.98559 40.7629C4.45715 40.3011 5.01615 39.9382 5.62981 39.6952C6.24347 39.4523 6.89945 39.3343 7.5593 39.3482H20.6252C21.9381 39.3462 23.1967 38.8239 24.1252 37.8957L29.7777 32.2453L36.4846 25.5341L38.6721 23.3466L45.9215 16.095C46.6146 15.4019 47.4976 14.9297 48.459 14.7382C49.4203 14.5466 50.4169 14.6443 51.3228 15.0188C52.2286 15.3933 53.0032 16.0279 53.5486 16.8424C54.094 17.6569 54.3858 18.6148 54.3871 19.595L54.3981 19.5928Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8562 14.4019C31.695 14.4019 33.1856 12.9113 33.1856 11.0725C33.1856 9.23378 31.695 7.74316 29.8562 7.74316C28.0175 7.74316 26.5269 9.23378 26.5269 11.0725C26.5269 12.9113 28.0175 14.4019 29.8562 14.4019Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3077 19.1109V27.7122L32.1202 29.8997L25.4067 36.6153V19.1153C25.4067 18.8832 25.4989 18.6607 25.663 18.4966C25.8271 18.3325 26.0497 18.2403 26.2817 18.2403H33.4217C33.5372 18.2389 33.6518 18.2603 33.7589 18.3033C33.8661 18.3464 33.9636 18.4102 34.046 18.4911C34.1283 18.5721 34.1939 18.6685 34.2388 18.7749C34.2837 18.8813 34.3071 18.9955 34.3077 19.1109Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.384 23.9062L17.3896 27.9006",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3839 29.7734L16.5977 34.5619",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_6976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailPoiEscalator);
export default __webpack_public_path__ + "static/media/detail-poi-escalator.f0c0793bf9f90d54c167ac570b546e88.svg";
export { ForwardRef as ReactComponent };